




























































































































































































































































































import Vue, { PropType } from 'vue';
// import { ItemData } from '@/modules/exhibitor/item';
// import { Brand } from '@/modules/exhibitor/brand';
// import { Option, options } from 'mostra';
import {
  Option,
  options,
  Item,
  Brand,
} from 'mostra';
// import {
//   Option,
//   // brandData,
//   deliveryDateYears,
//   deliveryDateMonths,
//   deliveryDatePartOfMonths,
//   itemCategories,
// } from '@/modules/options';
import { formatJP } from '@/modules/currency';

export type DataType = {
  // brandData: Option;
  hoge: boolean;
  // priceIncludeTax: number;
  deliveryDateTypes: Option;
  taxTypes: Option;
  itemPublishedTypes: Option;
  deliveryDateYears: Option;
  deliveryDateMonths: Option;
  deliveryDatePartOfMonths: Option;
  itemCategories: Option;
  isChange: boolean;
  formatJP: Function;
};

export default Vue.extend({
  name: 'GItemSettingForm',
  props: {
    item: {
      type: Object as PropType<Item>,
      required: true,
    },
    brands: {
      type: Array as PropType<Brand[]>,
      default: () => ([]),
    },
    isEdit: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data(): DataType {
    return {
      // brandData: brandData,
      hoge: true,
      // priceIncludeTax: 0,
      deliveryDateTypes: options.deliveryDateTypes,
      taxTypes: options.taxTypes,
      itemPublishedTypes: options.itemPublishedTypes,
      deliveryDateYears: options.deliveryDateYears,
      deliveryDateMonths: options.deliveryDateMonths,
      deliveryDatePartOfMonths: options.deliveryDatePartOfMonths,
      itemCategories: options.itemCategories,
      isChange: false,
      formatJP: formatJP,
    };
  },
  computed: {
    publishedType: {
      get(): number {
        return this.item.data.base.publishedType;
      },
      set(val: number) {
        this.item.data.base.publishedType = val;
      },
    },
    subs(): any[] {
      if (this.categoryId) {
        const c: any = this.itemCategories.find((i: any) => i.value === this.item.data.category.categoryId);
        return c ? c.subs : [];
      } else {
        return [];
      }
    },
    brandOptions: {
      get(): any[] {
        if (!this.brands) return [];
        const opts = this.brands.map((brand) => ({
          value: brand.id, text: brand.data.base.name,
        }));
        return opts;
      },
    },
    isPriceUndecided: {
      get(): boolean {
        return this.item.data.base.isPriceUndecided;
      },
      set(bool: boolean) {
        this.item.data.base.isPriceUndecided = bool;
        if (bool === true) {
          this.price = 0;
          this.taxNotationType = 0;
        }
      },
    },
    price: {
      get(): number {
        return this.item.data.base.price;
      },
      set(val: number) {
        this.item.data.base.price = Number(val);
        // this.sumPriceIncludeTax(this.item.data.base.price);
      },
    },
    taxNotationType: {
      get(): number {
        return this.item.data.base.taxNotationType;
      },
      set(val: number) {
        this.item.data.base.taxNotationType = val;
        // this.sumPriceIncludeTax(this.item.data.base.price);
      },
    },
    deliveryDateType: {
      get(): number | null {
        return this.item.data.delivery.deliveryDateType;
      },
      set(val: number | null) {
        if (this.item.data.delivery.deliveryDateType !== val) {
          this.item.data.delivery.year = null;
          this.item.data.delivery.month = null;
          this.item.data.delivery.timing = null;
          this.item.data.delivery.remark = '';
        }
        this.item.data.delivery.deliveryDateType = val;
      },
    },
    categoryId: {
      get(): number | null {
        return this.item.data.category.categoryId;
      },
      set(val: number | null) {
        if (this.item.data.category.categoryId !== val) {
          this.item.data.category.subCategoryId = null;
          this.$nextTick(() => {
            (this.$refs.subCategoryId as any).validate();
          });
        }
        this.item.data.category.categoryId = val;
      },
    },
    priceIncludeTax(): number {
      const val = this.price;
      if (Number.isNaN(Number(val)) || !Number.isInteger(Number(val))) {
        // this.priceIncludeTax = 0;
        return 0;
      }
      if (this.item.data.base.taxNotationType === 1) {
        return Math.ceil(Number(val) + Number(val) / 10);
        // return;
      }
      // this.priceIncludeTax = Number(val);
      return Number(val);
    },
  },
  // methods: {
  //   sumPriceIncludeTax(val: number) {
  //     if (Number.isNaN(Number(val)) || !Number.isInteger(Number(val))) {
  //       this.priceIncludeTax = 0;
  //       return;
  //     }
  //     if (this.item.data.base.taxNotationType === 1) {
  //       this.priceIncludeTax = Math.ceil(Number(val) + Number(val) / 10);
  //       return;
  //     }
  //     this.priceIncludeTax = Number(val);
  //   },
  // },
  // mounted() {
  //   this.sumPriceIncludeTax(this.item.data.base.price);
  // },
});
